import { StyleRulesCallback } from '@material-ui/core/styles/withStyles';

export const decisionRegistryContainerStyles: StyleRulesCallback = () => ({
  textCenter: {
    textAlign: 'center'
  },
});
